<template>
  <form @submit.prevent="update()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="partnerInfoEditModalLabel">Car Edit</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          ref="modalCloseBtn"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-secondary"
              v-if="!this.formValue.id"
              style="margin-bottom: 14px; float: right"
              @click="openReplaceDriverModal()"
            >
              Add Driver
            </button>
            <button
              type="button"
              class="btn btn-success"
              v-if="!this.formValue.id"
              style="margin-bottom: 14px; margin-right: 10px; float: right"
              @click="selfDriven()"
            >
              Self Driven
            </button>
          </div>
        </div>
        <div
          v-if="this.formValue.id"
          class="card text-white"
          style="background-color: #0d2339; margin-bottom: 15px"
        >
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div
              class="spinner-border m-5"
              style="width: 4rem; height: 4rem"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="name">নাম</label>
                  <input
                    type="text"
                    v-model="formValue.name"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="mobile">মোবাইল নাম্বার</label>
                  <input
                    type="text"
                    disabled
                    v-model="formValue.mobile"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>ই-মেইল </label>
                  <input
                    type="email"
                    v-model="formValue.email"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="city_id">শহর</label>
                  <select v-model="formValue.city" class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option
                      v-for="city in cityList"
                      :key="city.id"
                      :value="city.id"
                    >
                      {{ city.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="bkash_name">বিকাশ নাম</label>
                  <input
                    type="text"
                    v-model="formValue.bkash_name"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="bkash_number">বিকাশ নাম্বার</label>
                  <input
                    type="text"
                    v-model="formValue.bkash_number"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="phone">অবস্থা </label>
                  <select v-model="formValue.status" class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option value="active">সচল</option>
                    <option value="inactive">নিষ্ক্রিয়</option>
                    <option value="blocked">ব্লকড</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <button
                  type="button"
                  class="btn btn-secondary"
                  style="margin-top: 24px"
                  @click="openReplaceDriverModal()"
                >
                  {{ this.formValue.id ? 'Replace' : 'Add' }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  v-if="this.formValue.id"
                  style="margin-top: 24px; margin-left: 10px"
                  @click="removeDriver()"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.formValue.id"
          class="card text-white"
          style="background-color: #183757; margin-bottom: 15px"
        >
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div
              class="spinner-border m-5"
              style="width: 4rem; height: 4rem"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else class="card-body">
            <div class="row person">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="garage_location">গ্যারেজ লোকেশন</label>
                  <select
                    v-model="formValue.garage_location"
                    class="form-select"
                  >
                    <option value="">নির্বাচন করুন</option>
                    <option
                      v-for="area in areaList"
                      :key="area.id"
                      :value="area.id"
                    >
                      {{ area.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="phone">পছন্দের ড্রপ লোকেশন</label>
                  <select v-model="formValue.drop_location" class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option
                      v-for="area in areaList"
                      :key="area.id"
                      :value="area.id"
                    >
                      {{ area.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="phone">আপনি কি গাড়িটির মালিক?</label>
                  <select v-model="formValue.is_owner" class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option value="Yes">হ্যাঁ</option>
                    <option value="No">না</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="phone">স্ব-চালিত নাকি ড্রাইভার চালিত?</label>
                  <select v-model="formValue.is_driven_by" class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option value="Self-Driven">স্ব-চালিত</option>
                    <option value="Driver-Driven">ড্রাইভার চালিত</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="phone" style="margin-top: 24px"
                    >রাইড শেয়ারিং সার্ভিসের অন্তর্ভূক্ত?</label
                  >
                  <select
                    v-model="formValue.is_ride_sharing_service_included"
                    class="form-select"
                  >
                    <option value="">নির্বাচন করুন</option>
                    <option value="Yes">হ্যাঁ</option>
                    <option value="No">না</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >আপনি কি আপনার গাড়ি রেন্টালে দিতে ইচ্ছুক?</label
                  >
                  <select
                    v-model="formValue.interest_in_rental_service"
                    class="custom-select form-select"
                  >
                    <option value="">নির্বাচন করুন</option>
                    <option value="Yes">হ্যাঁ</option>
                    <option value="No">না</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="change_license_type" style="margin-top: 24px"
                    >ড্রাইভার লাইসেন্স টাইপ</label
                  >
                  <select
                    v-model="formValue.license_type"
                    class="custom-select form-select"
                  >
                    <option value="">নির্বাচন করুন</option>
                    <option value="Professional">Professional</option>
                    <option value="Personal">Personal</option>
                  </select>
                </div>
              </div>
              <!-- <div class="col-md-3">
                <div class="form-group">
                  <label for="role" style="margin-top: 24px">রোল</label>
                  <select
                    v-model="formValue.role"
                    class="custom-select form-select"
                  >
                    <option value="">নির্বাচন করুন</option>
                    <option value="owner">Owner</option>
                    <option value="driver">Driver</option>
                  </select>
                </div>
              </div> -->
            </div>
            <!-- <div class="row owner" style="display: none">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="type">ধরন</label>
                  <select class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option value="Personal">ব্যক্তিগত</option>
                    <option value="Company">কোম্পানি</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="name">কোম্পানি নাম</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="phone">কোম্পানি ঠিকানা</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="drop_locations">পছন্দের ড্রপ লোকেশন</label>
                  <select class="form-select"></select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="garage_locations">ফ্লিট লোকেশন </label>
                  <select class="form-select"></select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>গাড়ির সংখ্যা </label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="is_owner">আপনি কি গাড়িটির মালিক?</label>
                  <select class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option value="Yes">হ্যাঁ</option>
                    <option value="No">না</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="is_ride_sharing_service_included"
                    >রাইড শেয়ারিং সার্ভিসের অন্তর্ভূক্ত?</label
                  >
                  <select class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option value="Yes">হ্যাঁ</option>
                    <option value="No">না</option>
                  </select>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div
          class="card text-white"
          style="background-color: #3e454d; margin-bottom: 15px"
        >
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div
              class="spinner-border m-5"
              style="width: 4rem; height: 4rem"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label for="car_type">গাড়ির ধরন</label>
                <select v-model="formValue.car_type" class="form-select">
                  <option value="">নির্বাচন করুন</option>
                  <option
                    v-for="carType in carTypeList"
                    :key="carType.id"
                    :value="carType.id"
                  >
                    {{ carType.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label for="car_brand">গাড়ির ব্র্যান্ড</label>
                <select v-model="formValue.car_brand" class="form-select">
                  <option value="">নির্বাচন করুন</option>
                  <option
                    v-for="carBrand in carBrandList"
                    :key="carBrand.id"
                    :value="carBrand.id"
                  >
                    {{ carBrand.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="car_model">গাড়ির মডেল</label>
                  <select v-model="formValue.car_model" class="form-select">
                    <option value="">নির্বাচন করুন</option>
                    <option
                      v-for="carModel in carModelList"
                      :key="carModel.id"
                      :value="carModel.id"
                    >
                      {{ carModel.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label for="license_plate_number">লাইসেন্স প্লেট নাম্বার</label>
                <input
                  class="form-control"
                  v-model="formValue.license_plate_number"
                  type="text"
                  placeholder="টাইপ করুন (৭-১০ ডিজিটের মধ্যে)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="card bg-default">
          <div v-if="isLoading" class="d-flex justify-content-center">
            <div
              class="spinner-border m-5"
              style="width: 4rem; height: 4rem"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else class="card-body">
            <!-- Driver's Row -->
            <div class="row" v-if="this.formValue.id">
              <div class="col-sm-3">
                <ImageCard
                  :title="'ড্রাইভার প্রোফাইল পিকচার'"
                  :param="'profile_picture'"
                  :preview="preview['profile_picture']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="profile_picture"
                  @change="changePhoto('profile_picture')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'ড্রাইভিং লাইসেন্স'"
                  :param="'driving_license'"
                  :preview="preview['driving_license']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="driving_license"
                  @change="changePhoto('driving_license')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'ড্রাইভার NID'"
                  :param="'national_id'"
                  :preview="preview['national_id']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="national_id"
                  @change="changePhoto('national_id')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'ড্রাইভার ভ্যাকসিন সার্টিফিকেট'"
                  :param="'vaccine_certificate'"
                  :preview="preview['vaccine_certificate']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="vaccine_certificate"
                  @change="changePhoto('vaccine_certificate')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির রেজিস্ট্রেশন কাগজ'"
                  :param="'registration_number'"
                  :preview="preview['registration_number']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="registration_number"
                  @change="changePhoto('registration_number')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'ট্যাক্স টোকেন'"
                  :param="'tax_token'"
                  :preview="preview['tax_token']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="tax_token"
                  @change="changePhoto('tax_token')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'ফিটনেস সার্টিফিকেট'"
                  :param="'fitness_certificate'"
                  :preview="preview['fitness_certificate']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="fitness_certificate"
                  @change="changePhoto('fitness_certificate')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(front)'"
                  :param="'car_image'"
                  :preview="preview['car_image']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_image"
                  @change="changePhoto('car_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(back)'"
                  :param="'car_back_image'"
                  :preview="preview['car_back_image']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_back_image"
                  @change="changePhoto('car_back_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(side)'"
                  :param="'car_side_image'"
                  :preview="preview['car_side_image']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_side_image"
                  @change="changePhoto('car_side_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
              <div class="col-sm-3">
                <ImageCard
                  :title="'গাড়ির ছবি(interior)'"
                  :param="'car_interior_image'"
                  :preview="preview['car_interior_image']"
                  :data="allPartnerInfo"
                  :partner="carPartnerInfo"
                  :baseUrl="baseUrl"
                  @selectPhoto="selectPhoto"
                  @removePhoto="removePhoto"
                  @previewPhoto="previewPhoto"
                ></ImageCard>
                <input
                  ref="car_interior_image"
                  @change="changePhoto('car_interior_image')"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  style="display: none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary">Submit</button>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/config/axios';
import ImageCard from './imageCard.vue';

export default {
  props: [
    'baseUrl',
    'partner',
    'driver',
    'car',
    'cityList',
    'areaList',
    'carTypeList',
    'carBrandList',
    'carModelList'
  ],
  components: {
    ImageCard
  },
  data() {
    return {
      formValue: {},
      allPartnerInfo: [],
      preview: {
        registration_number: null,
        fitness_certificate: null,
        tax_token: null,
        car_image: null,
        car_back_image: null,
        car_side_image: null,
        car_interior_image: null,
        driving_license: null,
        vaccine_certificate: null,
        national_id: null,
        profile_picture: null
      },
      previewTitle: {
        registration_number: 'গাড়ির রেজিস্ট্রেশন কাগজ',
        fitness_certificate: 'ফিটনেস সার্টিফিকেট',
        tax_token: 'ট্যাক্স টোকেন',
        car_image: 'গাড়ির ছবি(front)',
        car_back_image: 'গাড়ির ছবি(back)',
        car_side_image: 'গাড়ির ছবি(side)',
        car_interior_image: 'গাড়ির ছবি(interior)',
        driving_license: 'ড্রাইভিং লাইসেন্স',
        vaccine_certificate: 'ড্রাইভার ভ্যাকসিন সার্টিফিকেট',
        national_id: 'ড্রাইভার NID',
        profile_picture: 'ড্রাইভার প্রোফাইল পিকচার'
      },
      isLoading: false,
      carPartnerInfo: {}
    };
  },
  watch: {
    // driver: function () {
    //   if (this.driver) {
    //     this.formValue.id = this.driver.user_code;
    //   }
    //   this.getAllPartnerInfo();
    //   this.emptyPhotoPreviews();
    // },
    car: function () {
      if (this.car) {
        this.getAllCarInfo();
        this.emptyPhotoPreviews();
      }
    }
  },
  methods: {
    getIdFromName(data, name) {
      let result = data.find((ele) => name === ele.name);
      return result ? result.id : '';
    },
    setFormValues(data) {
      this.formValue = {
        bkash_name: data.driver_info?.bkash_name,
        bkash_number: data.driver_info?.bkash_number,
        car_id: this.car.id,
        car_back_image: null,
        car_brand: data.car_brand,
        car_image: null,
        car_interior_image: null,
        car_model: data.car_model,
        car_side_image: null,
        car_type: data.car_type,
        city: data.driver_info?.city,
        company_location: data.driver_info?.company_location,
        company_name: data.driver_info?.company_name,
        driving_license: null,
        drop_location: data.driver_info?.drop_location,
        email: data.driver_info?.email,
        fitness_certificate: null,
        garage_location: data.driver_info?.garage_location,
        id: data.driver_code,
        // role: data.driver_info?.role,
        interest_in_rental_service:
          data.driver_info?.interest_in_rental_service,
        is_driven_by: data.driver_info?.is_driven_by,
        is_owner: data.driver_info?.is_owner,
        is_ride_sharing_service_included:
          data.driver_info?.is_ride_sharing_service_included,
        license_plate_number: data.license_plate_number,
        license_type: data.driver_info?.license_type,
        mobile: data.driver_info?.mobile,
        name: data.driver_info?.name,
        national_id: null,
        number_of_car: data.driver_info?.number_of_car,
        password: null,
        profile_picture: null,
        registration_number: data.registration_number,
        status: data.driver_info?.status,
        tax_token: null,
        type: data.driver_info?.type,
        vaccine_certificate: null,
        user_token: localStorage.getItem('token')
      };

      for (const key in this.formValue) {
        if (!this.formValue[key]) {
          this.formValue[key] = '';
        }
      }
    },
    emptyPhotoPreviews() {
      for (const key in this.preview) {
        this.preview[key] = null;
        // this.$refs[key].value = this.$refs[key].defaultValue;
      }
    },
    emptyFormValues() {
      for (const key in this.formValue) {
        this.formValue[key] = '';
      }
    },
    selectPhoto(param) {
      this.$refs[param].click();
    },
    changePhoto(param) {
      let reader = new FileReader();
      reader.onload = (e) => (this.preview[param] = e.target.result);
      reader.readAsDataURL(this.$refs[param].files[0]);
    },
    removePhoto(param) {
      this.preview[param] = null;
      this.$refs[param].value = this.$refs[param].defaultValue;
    },
    previewPhoto(param) {
      let _this = this;
      let images = [];
      let index = 0;
      let selectedImageIndex = 0;

      function pushImage(key, imagePath) {
        images.push({
          name: _this.previewTitle[key],
          path: imagePath
        });
        if (param == key) {
          selectedImageIndex = index;
        }
        index++;
      }

      for (const key in this.preview) {
        if (this.preview[key]) {
          pushImage(key, this.preview[key]);
        } else if (this.carPartnerInfo && this.carPartnerInfo[key]) {
          pushImage(key, this.baseUrl + 'upload/' + this.carPartnerInfo[key]);
        }
      }

      this.emitter.emit('setImagesForImageViewer', {
        images,
        selectedImageIndex
      });
      this.emitter.emit('showImageViewer');
    },
    // getAllPartnerInfo() {
    //   this.isLoading = true;
    //   http
    //     .post('/v2/partners/edit', {
    //       id: this.driver.user_code
    //     })
    //     .then((response) => {
    //       this.isLoading = false;
    //       if (response.status == 200) {
    //         this.allPartnerInfo = response.data.data;
    //         this.setFormValues(this.allPartnerInfo);
    //       } else {
    //         this.$swal('Error', 'Something went wrong!', 'error');
    //       }
    //     })
    //     .catch((error) => {
    //       this.isLoading = false;
    //       console.log(error);
    //       this.$swal('Error', 'Something went wrong!', 'error');
    //     });
    // },
    mergeCarPartnerInfo(hierarchicalData) {
      let driverInfo = hierarchicalData.driver_info;
      this.carPartnerInfo = { ...hierarchicalData, ...driverInfo };
      delete this.carPartnerInfo.driver_info;
    },
    getAllCarInfo() {
      this.isLoading = true;
      http
        .get(`/v2/partners/carInfo/${this.car.id}`)
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.allPartnerInfo = response.data.data;
            console.log(this.allPartnerInfo);
            this.mergeCarPartnerInfo(this.allPartnerInfo);
            this.setFormValues(this.allPartnerInfo);
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', 'Something went wrong!', 'error');
        });
    },
    openReplaceDriverModal() {
      this.$emit('openReplaceDriverModal', {
        car_id: this.car.id,
        license_plate_number: this.allPartnerInfo?.license_plate_number,
        driver_code: this.allPartnerInfo?.driver_code,
        user_id: this.allPartnerInfo?.user_id,
        driver_name: this.allPartnerInfo?.driver_info?.name
      });
    },
    update() {
      this.isLoading = true;
      // Making of the form
      let formData = new FormData();
      Object.keys(this.formValue).map((e) => {
        if (this.formValue[e]) {
          formData.append(e, this.formValue[e]);
        }
      });
      Object.keys(this.preview).map((e) => {
        if (this.preview[e]) {
          formData.append(e, this.$refs[e].files[0]);
        }
      });

      http
        .post('/v2/partners/carUpdate', formData)
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.$swal('Success', response.data.message, 'success');
            this.emptyPhotoPreviews();
            this.$emit('refreshPaginationData');
            this.$refs.modalCloseBtn.click();
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', 'Something went wrong!', 'error');
        });
    },
    removeDriver() {
      http
        .post('/v2/partners/removeDriverFromCar', {
          car_id: this.formValue.car_id,
          driver_code: this.allPartnerInfo?.driver_code,
          user_id: this.allPartnerInfo?.user_id
        })
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.$swal('Success', response.data.message, 'success');
            this.emptyPhotoPreviews();
            this.$emit('refreshPaginationData');
            this.$refs.modalCloseBtn.click();
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', 'Something went wrong!', 'error');
        });
    },
    selfDriven() {
      http
        .post('/v2/partners/selfDriven', {
          car_id: this.formValue.car_id,
          user_id: this.allPartnerInfo?.user_id
        })
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.$swal('Success', response.data.message, 'success');
            this.emptyPhotoPreviews();
            this.$emit('refreshPaginationData');
            this.$refs.modalCloseBtn.click();
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', error.response.data.message, 'error');
        });
    }
  }
};
</script>

<style scoped>
select,
input {
  margin-bottom: 10px;
}
</style>
